module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");

// CONCATENATED MODULE: ./src/Typography/Typography.ts
var Typography = {
  fontFamily: "'Brandon Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  fontSize: '20px',
  brandOne: {
    size: '74px',
    height: '35px'
  },
  brandTwo: {
    size: '64px',
    height: '60px'
  },
  brandThree: {
    size: '38px',
    height: '39px'
  },
  headerOne: {
    size: '42px',
    height: '28px'
  },
  headerTwo: {
    size: '28px',
    height: '32px'
  },
  headerThree: {
    size: '24px',
    height: '28px'
  },
  headerFour: {
    size: '22px',
    height: '28px'
  },
  headerFive: {
    size: '20px',
    height: '28px'
  },
  headerSix: {
    size: '18px',
    height: '28px'
  },
  headerSeven: {
    size: '16px',
    height: '28px'
  },
  headerEight: {
    size: '14px',
    height: '28px'
  },
  headerNine: {
    size: '12px',
    height: '28px'
  },
  bodyOne: {
    size: '26px',
    height: '32px'
  },
  bodyTwo: {
    size: '18px',
    height: '24px'
  },
  bodyThree: {
    size: '16px',
    height: '24px'
  },
  bodyFour: {
    size: '14px',
    height: '20px'
  },
  bodyFive: {
    size: '12px',
    height: '18px'
  }
};
/* harmony default export */ var Typography_Typography = (Typography);
// CONCATENATED MODULE: ./src/Typography/index.ts

/* harmony default export */ var src_Typography = (Typography_Typography);
// CONCATENATED MODULE: ./src/ThemeProvider/ThemeProvider.tsx



var CarvanaTheme = {
  carvana: {
    // 2.0 palette -- https://carvana.invisionapp.com/share/8CH6ZTCX5ER#/screens
    body: '#e4ecf0',
    blue: {
      primary: '#00aed9',
      // links, primary buttons, icons
      hover: '#018dc0',
      // hover state
      medium: '#00619e',
      // sticky header background
      dark: '#183558',
      // navigation header background, headlines, text
      pastel: '#cfeaf2' // accent

    },
    gray: {
      background: '#f4f8fa',
      // main background within 1800px
      light: '#d9dde9',
      // secondary copy, tabs and field outlines, lines
      medium: '#aab1c7',
      // icons, unselected heart icon
      dark: '#757989' // text and icons

    },
    green: {
      primary: '#1dd08b' // success green

    },
    red: {
      primary: '#ff7171' // alert red, faved

    },
    yellow: {
      primary: '#feb948',
      // secondary buttons, attentions icons
      hover: '#eb9f23',
      // hover state
      pastel: '#fbf2de' // accent

    },
    white: {
      primary: '#ffffff'
    },
    stroke: {
      blue: '#122946' // divider line color in header and footer

    },
    impersonationRed: '#ff0000'
  },
  typography: src_Typography,
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1280,
      xl: 1920
    }
  }
};

var ThemeProvider_ThemeProvider = function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? CarvanaTheme : _ref$theme,
      children = _ref.children;
  return external_react_default.a.createElement(external_styled_components_["ThemeProvider"], {
    theme: theme
  }, external_react_default.a.createElement(external_react_default.a.Fragment, null, children));
};

/* harmony default export */ var src_ThemeProvider_ThemeProvider = (ThemeProvider_ThemeProvider);
// CONCATENATED MODULE: ./src/Font/Font.config.ts
var fontConfig = {
  cdnBaseUrl: {
    development: 'https://assets.zagforward.com',
    test: 'https://assets.carvanatech.com',
    uat: 'https://resources.cvuat.com',
    prod: 'https://assets.cvnaassets.com'
  }
};
/* harmony default export */ var Font_config = (fontConfig);
// CONCATENATED MODULE: ./src/Font/Font.ts



var Font_Font = function Font(environment) {
  return Object(external_styled_components_["css"])(["@font-face{font-family:'Brandon Text';font-display:auto;font-weight:300;font-style:normal;src:url(", "/fonts/BrandonText-Light.otf);}@font-face{font-family:'Brandon Text';font-display:auto;font-weight:400;font-style:normal;src:url(", "/fonts/BrandonText-Regular.otf);}@font-face{font-family:'Brandon Text';font-display:auto;font-weight:700;font-style:normal;src:url(", "/fonts/BrandonText-Bold.otf);}"], Font_config.cdnBaseUrl[environment], Font_config.cdnBaseUrl[environment], Font_config.cdnBaseUrl[environment]);
};

/* harmony default export */ var src_Font_Font = (Font_Font);
// CONCATENATED MODULE: ./src/Font/index.ts

/* harmony default export */ var src_Font = (src_Font_Font);
// CONCATENATED MODULE: ./src/Reset/Reset.ts
var Reset = "\n/*!\n * Bootstrap Reboot v4.0.0 (https://getbootstrap.com)\n * Copyright 2011-2018 The Bootstrap Authors\n * Copyright 2011-2018 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n * Forked from Normalize.css, licensed MIT (https://github.com/necolas/normalize.css/blob/master/LICENSE.md)\n*/\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@-ms-viewport {\n  width: device-width;\n}\n\narticle, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Brandon Text\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: left;\n  background-color: #fff;\n}\n\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\ndfn {\n  font-style: italic;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -.25em;\n}\n\nsup {\n  top: -.5em;\n}\n\na {\n  color: #007bff;\n  text-decoration: none;\n  background-color: transparent;\n  -webkit-text-decoration-skip: objects;\n}\n\na:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n}\n\na:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {\n  color: inherit;\n  text-decoration: none;\n}\n\na:not([href]):not([tabindex]):focus {\n  outline: 0;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: .5rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  -webkit-appearance: listbox;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n";
/* harmony default export */ var Reset_Reset = (Reset);
// CONCATENATED MODULE: ./src/Reset/index.ts

/* harmony default export */ var src_Reset = (Reset_Reset);
// CONCATENATED MODULE: ./src/GlobalStyle/GlobalStyle.tsx
function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }





var GlobalStyle_GlobalStyle = function GlobalStyle(environment, additionalStyles) {
  var font = src_Font(environment);
  return Object(external_styled_components_["createGlobalStyle"])(_templateObject(), font, src_Reset, additionalStyles);
};

/* harmony default export */ var src_GlobalStyle_GlobalStyle = (GlobalStyle_GlobalStyle);
// CONCATENATED MODULE: ./src/GlobalStyle/index.ts

/* harmony default export */ var src_GlobalStyle = (src_GlobalStyle_GlobalStyle);
// CONCATENATED MODULE: ./src/ThemeUtilities/ThemeUtilities.ts
var getThemeColor = function getThemeColor(color) {
  return function (_ref) {
    var carvana = _ref.theme.carvana;
    return carvana[color];
  };
};

var getColorVariant = function getColorVariant(color) {
  return function (variant) {
    return function (_ref2) {
      var carvana = _ref2.theme.carvana;
      return carvana[color][variant];
    };
  };
};

var getBreakpointValue = function getBreakpointValue(size) {
  return function (_ref3) {
    var values = _ref3.theme.breakpoints.values;
    return values[size];
  };
};

var cvTypography = function cvTypography(attr) {
  return function (_ref4) {
    var typography = _ref4.theme.typography;
    return typography[attr];
  };
};

var cvGray = getColorVariant('gray');
var cvRed = getColorVariant('red');
var cvWhite = getColorVariant('white');
var cvBlue = getColorVariant('blue');
var cvGreen = getColorVariant('green');
var cvYellow = getColorVariant('yellow');
var cvStroke = getColorVariant('stroke');
var cvBody = getThemeColor('body');
var cvImpersonationRed = getThemeColor('impersonationRed');
var cvFontFamily = cvTypography('fontFamily');
var cvFontSize = cvTypography('fontSize');
var cvBreakpoint0 = getBreakpointValue('xs');
var cvBreakpoint768 = getBreakpointValue('sm');
var cvBreakpoint1024 = getBreakpointValue('md');
var cvBreakpoint1280 = getBreakpointValue('lg');
var cvBreakpoint1920 = getBreakpointValue('xl');

// CONCATENATED MODULE: ./src/index.ts
/* concated harmony reexport CarvanaTheme */__webpack_require__.d(__webpack_exports__, "CarvanaTheme", function() { return CarvanaTheme; });
/* concated harmony reexport ThemeProvider */__webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return src_ThemeProvider_ThemeProvider; });
/* concated harmony reexport Font */__webpack_require__.d(__webpack_exports__, "Font", function() { return src_Font; });
/* concated harmony reexport Reset */__webpack_require__.d(__webpack_exports__, "Reset", function() { return src_Reset; });
/* concated harmony reexport createGlobalStyle */__webpack_require__.d(__webpack_exports__, "createGlobalStyle", function() { return src_GlobalStyle; });
/* concated harmony reexport cvGray */__webpack_require__.d(__webpack_exports__, "cvGray", function() { return cvGray; });
/* concated harmony reexport cvRed */__webpack_require__.d(__webpack_exports__, "cvRed", function() { return cvRed; });
/* concated harmony reexport cvWhite */__webpack_require__.d(__webpack_exports__, "cvWhite", function() { return cvWhite; });
/* concated harmony reexport cvBlue */__webpack_require__.d(__webpack_exports__, "cvBlue", function() { return cvBlue; });
/* concated harmony reexport cvYellow */__webpack_require__.d(__webpack_exports__, "cvYellow", function() { return cvYellow; });
/* concated harmony reexport cvGreen */__webpack_require__.d(__webpack_exports__, "cvGreen", function() { return cvGreen; });
/* concated harmony reexport cvStroke */__webpack_require__.d(__webpack_exports__, "cvStroke", function() { return cvStroke; });
/* concated harmony reexport cvBody */__webpack_require__.d(__webpack_exports__, "cvBody", function() { return cvBody; });
/* concated harmony reexport cvImpersonationRed */__webpack_require__.d(__webpack_exports__, "cvImpersonationRed", function() { return cvImpersonationRed; });
/* concated harmony reexport cvFontFamily */__webpack_require__.d(__webpack_exports__, "cvFontFamily", function() { return cvFontFamily; });
/* concated harmony reexport cvFontSize */__webpack_require__.d(__webpack_exports__, "cvFontSize", function() { return cvFontSize; });
/* concated harmony reexport cvBreakpoint0 */__webpack_require__.d(__webpack_exports__, "cvBreakpoint0", function() { return cvBreakpoint0; });
/* concated harmony reexport cvBreakpoint768 */__webpack_require__.d(__webpack_exports__, "cvBreakpoint768", function() { return cvBreakpoint768; });
/* concated harmony reexport cvBreakpoint1024 */__webpack_require__.d(__webpack_exports__, "cvBreakpoint1024", function() { return cvBreakpoint1024; });
/* concated harmony reexport cvBreakpoint1280 */__webpack_require__.d(__webpack_exports__, "cvBreakpoint1280", function() { return cvBreakpoint1280; });
/* concated harmony reexport cvBreakpoint1920 */__webpack_require__.d(__webpack_exports__, "cvBreakpoint1920", function() { return cvBreakpoint1920; });
/* concated harmony reexport cvTypography */__webpack_require__.d(__webpack_exports__, "cvTypography", function() { return cvTypography; });





/* harmony default export */ var src = __webpack_exports__["default"] = (src_ThemeProvider_ThemeProvider);


/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map